/* tslint:disable:interface-name */
import { SerializableParams } from '../../utils';

import { SerializableObject } from '../data/serializable-object';
import { MobizServerApi } from '../other/mobiz-server-api.enum';

import { ParameterValueType } from './dictionary.interface';

/**
 * Union type for all possible body values in HTTP requests.
 *
 * If no header is provided in the request configuration, then these will be added by default:
 *   - `application/json` - for text
 *   - `multipart/form-data` - for `FormData`, which can also include File instances
 *   - `application/x-www-form-urlencoded` - for `SerializableParams`
 *   - `application/json` - for `SerializableObject`
 */
export type RequestBodyValue = undefined | string | FormData | SerializableObject | SerializableParams;

/**
 * Property bag used for generating a Mobiz api endpoint.
 *
 * TODO: Rename to `IRequestConfig<Endpoint = ...>`.
 */
export interface ApiEndpointConfiguration<A = MobizServerApi> {
  /**
   * The server Api endpoint.
   */
  serverApi: A;
  /**
   * The custom headers for the request.
   */
  headers?: Record<string, string> | Headers;
  /**
   * Property bag with parameters that will get embedded in the api endpoint.
   */
  urlParameters?: Record<string, ParameterValueType>;
  /**
   * Property bag with parameters that will be added in the query string part of the api endpoint.
   */
  queryParameters?: Record<string, ParameterValueType>;
  /**
   * Body of the http request.
   */
  body?: RequestBodyValue;
  /**
   * Flag to used disable the error handling. Useful for services and components that have special requirements.
   *
   * @deprecated this flag is no longer used, the global error error handler will handle uncaught HTTP client errors.
   */
  disableErrorHandling?: boolean;
  
  /**
   * Timeout in milliseconds for the HTTP request.
   */
  timeout?: number;
}
